import { number, shape, string } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const Location = shape({
  LocationId: number.isRequired,
  SiteId: number.isRequired,
  Title: string.isRequired,
});

